import { SCOPE_CURRENCY_SET } from "constants/action-types";
import "rxjs/add/operator/map";
import { clearInsightsData } from "actions/insights-actions";
import { isInsightsPermissionEnabled } from "reducers/insights-reducer";

export const updateCurrencyEpic = (action$, store) =>
    action$.ofType(SCOPE_CURRENCY_SET).mergeMap((action) => {
        const state = store.getState();

        if (!isInsightsPermissionEnabled(state)) {
            return [];
        }

        if (action.payload.toLowerCase() !== "usd") {
            return [clearInsightsData()];
        }

        return [];
    });
